function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="evenodd"><path d="M18 36c9.941 0 18-8.06 18-18 0-9.941-8.06-18-18-18C8.059 0 0 8.06 0 18c0 9.941 8.06 18 18 18" /><path d="M11.999 26.817H9.89l9.447-8.741-8.262-8.977h14.706v1.572h-11.29l6.806 7.405-7.271 7.04h12.173v1.702H12.003" fill="#434242" /></g></svg>;
});